import HeaderReport from "../../header/report";
import libForm from "../../../util/libForm";
import RadioInput from "../../inputs/radio";
import TextInput from "../../inputs/text";
import { useEffect } from "react";
import { IndexHook } from "./hook";
import { Switch } from "@mui/material";
import { BtnSearch } from "../../button/button-search";
import HeaderFilter from "../../header/filter";

//todo filtro basico de pesquisa

const FilterRegister = ({ options, handleSubmitModalFilter, reloadFilter }) => {
	const parameters = options.parametersFilter;

	const {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		setValue,
		control,
		Controller,
	} = IndexHook({ options, handleSubmitModalFilter });

	useEffect(() => {
		try {
			reloadFilter &&
				Object.keys(reloadFilter).forEach((field) => {
					setValue(field, reloadFilter[field]);
				});
		} catch (error) {}
	}, []);

	return (
		<div className="">
			<form onSubmit={handleSubmit(handleOnSubmit)} action="submit">
				<HeaderFilter title={options.title} />

				<div className="border-bottom">
					<div className="row mt-2">
						{parameters.map((item) => (
							<RadioInput key={item.id} item={item} id={"param"} register={register} control={control} />
						))}
					</div>
					<div className="flex-wrap ">
						<div className="check-input d-flex align-items-center justify-content-end">
							<Controller
								name="active"
								control={control}
								defaultValue={true}
								render={({ field }) => (
									<Switch
										checked={field.value}
										onChange={(e) => field.onChange(e.target.checked)}
										inputProps={{
											"aria-label": "Ativos",
										}}
									/>
								)}
							/>
							<label htmlFor="active">Ativo</label>
							{errors.active && <p className="errors">{errors.active.message}</p>}
						</div>
					</div>
					<TextInput
						label={paramSelected.label}
						id="paramValue"
						register={register}
						errors={errors}
						onKeyDown={libForm.EnterTab}
						autoFocus={true}
						className={"mt-2"}
					/>
				</div>
				<footer>
					<div></div>
					<BtnSearch isSubmitting={isSubmitting} />
				</footer>
			</form>
		</div>
	);
};

export default FilterRegister;
